<template>
	<div>
		<layout-6 :id=pageid :id2=pageid2 :id3=pageid3 :id4=pageid4 :docID="parseInt(term)" style="width:100%; height:calc(100vh - 50px);"></layout-6>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.EDIT_DOCUMENTS_PAGE,
			pageid2:PAGES.JOB_ORDERS_PAGE,
			pageid3:PAGES.SCHEDULES_PAGE,
			pageid4:PAGES.EDIT_JOB_ORDERS_PAGE,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/edit/Edit_Documents.vue